import React from 'react';

import FallbackSpinner from '../../components/loader/FallbackSpinner';
import createRouteLoadable from './createRouteLoadable';

export const MY_ACCOUNT_CHUNK_NAME = 'myAccount';

export const MY_ACCOUNT_THANK_YOU_PAGE_CHUNK_NAME = 'myAccountThankYouPage';

export const MyAccountPage = createRouteLoadable(
  () => import(/* webpackChunkName: "myAccount" */ '../../pages/MyAccountPage'),
  {
    fallback: <FallbackSpinner />,
  }
);

export const MyAccountThankYouPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "myAccountThankYouPage" */ '../../pages/MyAccountThankYouPage'
    ),
  {
    fallback: <FallbackSpinner />,
  }
);
